module.exports = __webpack_public_path__ + "img/retrospect-7-mobile.72969dec.jpg";